import React, { Component } from 'react'
import ReportMenu from '../../../constants/menu/report'
import { reportTypeService } from '../../../services'
import { auth, exportFile, formatter, validator } from '../../../util'

// UI
import { Button, List, Page, Pager } from '../../../components'
import { Permissions, ReportType } from '../../../constants'
import notify from '../../../components/Notification'
import Skeleton from 'antd/lib/skeleton'
import Spin from 'antd/lib/spin'

import '../styles.css'

const title = `Participants' Day Count Since Last Job`
const DefaultSort = { day_count: -1 }

class ReportDayCountLastJob extends Component {
  constructor (props) {
    super(props)
    this.state = {
      currentPage: 1,
      filter: {},
      list: { list: [], total: 0 },
      isGenerating: false,
      isLoaded: false,
      loading: false,
      loadingList: false,
      sort: Object.assign({}, DefaultSort)
    }
  }

  componentDidMount () {
    this.fetchReport()
  }

  render () {
    const { currentPage, isGenerating, list, loading, loadingList } = this.state

    const columns = [
      {
        title: 'Participant',
        width: 5,
        key: 'client_fullname',
        render: ({ client_ref_id, client_fullname }) => <a href={`/participants/${client_ref_id}/funding-plan`} rel='noopener noreferrer' target='_blank'>{client_fullname}</a>,
        onSort: (key, order) => this.handleSort({[key]: order})
      },
      {
        title: 'Plan End Date',
        width: 3,
        key: 'period_end_date',
        render: ({ period_end_date }) => <div>{formatter.toShortDate(period_end_date)}</div>,
        onSort: (key, order) => this.handleSort({[key]: order})
      },
      {
        title: 'Remaining SC Hours',
        width: 3,
        key: 'remaining_hrs',
        render: ({ remaining_hrs }) => <div>{formatter.toFloatDecimal(remaining_hrs)}</div>,
        onSort: (key, order) => this.handleSort({[key]: order})
      },
      {
        title: 'Last Job Date',
        width: 3,
        key: 'job_date',
        render: ({ job_date }) => <div>{job_date ? formatter.toShortDate(job_date) : `No Job available`}</div>,
        onSort: (key, order) => this.handleSort({[key]: order})
      },
      {
        title: 'Days Count',
        width: 2,
        key: 'day_count',
        render: ({ day_count }) => <div>{day_count === null ? 'N/A' : Math.floor(day_count)}</div>,
        onSort: (key, order) => this.handleSort({[key]: order})
      }
    ]

    return (
      <Page.Body>
        <Page.Left>
          <Page.Menu title='Home' menu={ReportMenu} />
        </Page.Left>


        <Page.Content full>
          <Page.Header title={title}>
            { this.hasAccess(Permissions.REPORT.DAY_COUNT_LAST_JOB.LIST)
              ? <Button feedback={isGenerating} onClick={() => this.export()}>
                EXPORT
              </Button>
              : null }
          </Page.Header>

          <div style={{marginTop: '24px'}}>
            <Skeleton loading={loading} active>
              <Spin spinning={loadingList}>
                <div className='report'>
                  <div className='report-title'>{`Participants' Job Day Counts `} <span className='report-tag'>{list.total}</span></div>
                  <List cols={columns} rows={list.list} />

                  <Pager
                    size={list.total}
                    total={list.total}
                    totalText={`Total ${list.total} Record${list.total === 1 ? '' : 's'}`}
                    current={currentPage}
                    onChange={(e) => this.onChangePage(e)}
                    style={{ marginTop: '15px' }}
                  />
                </div>
              </Spin>
            </Skeleton>
          </div>
        </Page.Content>
      </Page.Body>
    )
  }

  onChangePage = (page) => {
    this.setState({ currentPage: page }, () => {
      this.fetchReport()
    })
  }

  fetchReport = () => {
    const { currentPage, filter, isLoaded, loading, sort } = this.state
    this.fetchClientReport({ currentPage, filter, isLoaded, loading, sort })
  }

  fetchClientReport = async ({ currentPage, filter, isLoaded = true, loading, sort }) => {
    if (this.hasAccess(Permissions.REPORT.DAY_COUNT_LAST_JOB.LIST)) {
      if (isLoaded) {
        this.setState({ loadingList: true })
      } else {
        this.setState({ loading: true })
      }

      try {
        const list = await reportTypeService.listReport(ReportType.SC_DAY_COUNT_SINCE_LAST_JOB, filter, sort)

        if (list) {
          this.setState({
            list,
            isLoaded: true,
            loadingList: false,
            loading: false
          })
        } else {
          notify.error(`Unable to get ${title} Report`, 'Please try again later.')
        }
      } catch (e) {
        notify.error(`Unable to get ${title} Report`, 'Please try again later.')
      }

      if (window) window.scrollTo({ top: 0 })
    }
  }

  handleSort = (sort, statusType) => {
    for (var s in sort) {
      if (sort[s] === 0) {
        delete sort[s]
      }
    }

    if (!validator.isNotEmptyObject(sort)) {
      sort = Object.assign({}, DefaultSort)
    }

    this.setState({ sort, currentPage: 1 }, () => {
      this.fetchReport()
    })
  }

  export = async () => {
    try {
      this.setState({ isGenerating: true })

      const r = await exportFile.fetchReportExport(ReportType.SC_DAY_COUNT_SINCE_LAST_JOB)
      setTimeout(() => {
        this.setState({ isGenerating: false })
      }, 2000)
    } catch (e) {
      notify.error(`Unable to download ${title} Report`, 'Please try again later.')
    }
  }

  hasAccess (accessLevel) {
    return auth.hasAccess(accessLevel)
  }
}

export default ReportDayCountLastJob
